<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p>
        <span class="breadcrumb-item" @click="irInicio">Inicio</span> > Panel Publicista
      </p>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="titulo">
            <h5 class="mx-4 mt-5 mb-3">Panel Publicista</h5>
            <p class="mx-4 mb-4 text-sm opacity-7">
              Resumen de campañas, entradas, suscritos actuales, compras e importe por tipster.
            </p>
          </div>

          <!-- Filtros globales -->
          <div class="filtros-globales px-4 pb-4">

            <!-- Periodo -->
            <div class="filtro-bloque">
              <label class="filtro-label">Periodo</label>
              <div class="btn-group btn-group-sm" role="group">
                <button
                  v-for="p in periodos"
                  :key="p.key"
                  class="btn btn-sm mb-0"
                  :class="periodo === p.key ? 'btn-activo' : 'btn-inactivo'"
                  @click="setPeriodo(p.key)"
                >{{ p.label }}</button>
              </div>
            </div>

            <!-- Selector de tipster -->
            <div class="filtro-bloque" v-if="tipsters.length > 1">
              <label class="filtro-label">Tipster</label>
              <div class="select-wrap" style="min-width:200px">
                <select class="form-select" v-model="tipsterSeleccionado">
                  <option value="">Todos los tipsters</option>
                  <option v-for="t in tipsters" :key="t.tipster_id" :value="t.tipster_id">
                    {{ t.tipster_nombre }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Selector publicista (solo admin) -->
            <div class="filtro-bloque" v-if="canAdmin">
              <label class="filtro-label">Publicista</label>
              <div class="select-wrap" style="min-width:220px">
                <select class="form-select" v-model="publicistaId">
                  <option value="">-- Seleccione Publicista --</option>
                  <option v-for="p in publicistas" :key="p.id" :value="String(p.id)">
                    {{ p.name }} ({{ p.username }})
                  </option>
                </select>
              </div>
            </div>

            <div class="filtro-bloque" v-if="canAdmin">
              <QBtn variant="tipster" label="Cargar" :loading="loading" :disabled="loading" @click="cargarPanel" />
            </div>

          </div>

        </div>
      </div>
    </div>

    <!-- Resumen -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="card ficha-listado">
          <div class="px-4 pb-4 card-body">
            <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <div>
                <h6 class="mb-0">Resumen</h6>
                <p class="text-sm mb-0 opacity-7" v-if="publicistaLabel">
                  Publicista: <b>{{ publicistaLabel }}</b>
                </p>
              </div>
            </div>

            <div class="row g-3">
              <div class="col-6 col-md-4 col-lg-3">
                <div class="mini-card">
                  <div class="k">Campañas</div>
                  <div class="v">{{ resumenFiltrado.campanas_total }}</div>
                </div>
              </div>
              <div class="col-6 col-md-4 col-lg-3">
                <div class="mini-card">
                  <div class="k">Entradas al canal</div>
                  <div class="v">{{ resumenFiltrado.entradas_total }}</div>
                </div>
              </div>
              <div class="col-6 col-md-4 col-lg-3">
                <div class="mini-card">
                  <div class="k">Entradas únicas</div>
                  <div class="v">{{ resumenFiltrado.entradas_unicas_total }}</div>
                </div>
              </div>
              <div class="col-6 col-md-4 col-lg-3">
                <div class="mini-card">
                  <div class="k">Suscritos actuales</div>
                  <div class="v">{{ resumenFiltrado.suscritos_actuales_total }}</div>
                </div>
              </div>
              <div class="col-6 col-md-4 col-lg-3">
                <div class="mini-card">
                  <div class="k">Bajas</div>
                  <div class="v">{{ resumenFiltrado.salidas_total }}</div>
                </div>
              </div>
              <div class="col-6 col-md-4 col-lg-3">
                <div class="mini-card">
                  <div class="k">Compras</div>
                  <div class="v">{{ resumenFiltrado.compras_total }}</div>
                </div>
              </div>
              <div class="col-6 col-md-4 col-lg-3">
                <div class="mini-card">
                  <div class="k">Importe (€)</div>
                  <div class="v">{{ formatMoney(resumenFiltrado.importe_total) }}</div>
                </div>
              </div>
            </div>

            <div v-if="!loading && tipsters.length === 0" class="mt-4 alert alert-secondary text-sm">
              No hay datos para mostrar (¿sin tipsters asignados o sin campañas?).
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Comparativa de tipsters (solo si hay más de 1) -->
    <PanelPublicistaComparativa :tipsters="tipstersFiltrados" />

    <!-- Evolución mensual -->
    <PanelPublicistaEvolucion :key="'evo-' + panelKey" :evolucion="evolucionEntradas" :tipster-label="tipsterSeleccionado ? tipsters.find(t => t.tipster_id === Number(tipsterSeleccionado))?.tipster_nombre : ''" />

    <!-- Ranking de campañas -->
    <PanelPublicistaRanking :tipsters="tipstersFiltrados" />

    <!-- Distribución geográfica (Meta) -->
    <PanelPublicistaGeoMeta :key="'geo-' + panelKey" :countries="countriesMetaFiltrado" :periodo="periodo" />

    <!-- Landings más efectivas -->
    <PanelPublicistaLandingsEfectivas :key="'land-' + panelKey" :landings="landingsEfectivasFiltradas" />

    <!-- Listado de campañas (todas, ordenable) -->
    <div class="row mt-4" v-if="campanasSorted.length">
      <div class="col-12">
        <div class="card ficha-listado">
          <div class="px-4 pb-4 card-body">
            <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <div>
                <h6 class="mb-0">Detalle de campañas</h6>
                <p class="text-xs opacity-7 mb-0">{{ campanasSorted.length }} campañas · haz clic en una columna para ordenar</p>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-flush table-listado table-empirulada">
                <thead class="thead-light">
                  <tr>
                    <th class="th-sort" :class="thClass('fecha')" @click="setOrden('fecha')">Fecha</th>
                    <th class="th-sort" :class="thClass('campana_nombre')" @click="setOrden('campana_nombre')">Campaña</th>
                    <th class="th-sort" :class="thClass('tipster_nombre')" @click="setOrden('tipster_nombre')">Tipster</th>
                    <th class="th-sort text-center" :class="thClass('entradas_total')" @click="setOrden('entradas_total')">Entradas</th>
                    <th class="th-sort text-center" :class="thClass('entradas_unicas')" @click="setOrden('entradas_unicas')" title="Usuarios distintos que entraron al canal (sin contar reingresos)">E. Únicas</th>
                    <th class="th-sort text-center" :class="thClass('reingresos_total')" @click="setOrden('reingresos_total')" title="Personas que ya habían estado en el canal y volvieron a entrar">Reingresos</th>
                    <th class="th-sort text-center" :class="thClass('suscritos_actuales')" @click="setOrden('suscritos_actuales')">Suscritos</th>
                    <th class="th-sort text-center" :class="thClass('salidas_total')" @click="setOrden('salidas_total')">Bajas</th>
                    <th class="th-sort text-center" :class="thClass('compras')" @click="setOrden('compras')">Compras</th>
                    <th class="th-sort text-end sin-orden" :class="thClass('importe')" @click="setOrden('importe')">Importe</th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <tr v-for="c in campanasSorted" :key="c.campana_id">
                    <td>{{ fmtFechaDMY(c.fecha) }}</td>
                    <td><div class="campana-nombre">{{ c.campana_nombre || '-' }}</div></td>
                    <td><div class="canal-sub">{{ c.tipster_nombre }}</div></td>
                    <td class="text-center">{{ c.entradas_total }}</td>
                    <td class="text-center">{{ c.entradas_unicas }}</td>
                    <td class="text-center">
                      <span v-if="c.reingresos_total > 0" class="reingreso-badge">+{{ c.reingresos_total }}</span>
                      <span v-else class="text-muted">0</span>
                    </td>
                    <td class="text-center">{{ c.suscritos_actuales }}</td>
                    <td class="text-center">{{ c.salidas_total }}</td>
                    <td class="text-center">
                      <span
                        v-if="c.compras > 0"
                        class="compras-badge"
                        @click="abrirCompras(c.campana_id, c.campana_nombre)"
                        title="Ver detalle de compras"
                      >{{ c.compras }}</span>
                      <span v-else class="text-muted">0</span>
                    </td>
                    <td class="text-end">{{ formatMoney(c.importe) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Modal compras por campaña -->
  <Teleport to="body">
    <div v-if="comprasModal.visible" class="cp-overlay" @click.self="comprasModal.visible = false">
      <div class="cp-box">
        <div class="cp-header">
          <div>
            <div class="cp-titulo">Compras — {{ comprasModal.campanaNombre }}</div>
            <div v-if="!comprasModal.loading" class="cp-subtitulo">{{ comprasModal.filas.length }} {{ comprasModal.filas.length === 1 ? 'compra' : 'compras' }}</div>
          </div>
          <button class="cp-cerrar" @click="comprasModal.visible = false">✕</button>
        </div>
        <div class="cp-body">
          <div v-if="comprasModal.loading" class="cp-loading">
            <div class="cp-spinner"></div>
          </div>
          <div v-else-if="comprasModal.filas.length === 0" class="cp-empty">Sin compras registradas para esta campaña</div>
          <div v-else class="table-responsive">
            <table class="table table-sm cp-tabla">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Email</th>
                  <th>Nick Telegram</th>
                  <th class="text-end">Importe</th>
                  <th class="text-center">Fecha</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(f, i) in comprasModal.filas" :key="i">
                  <td>{{ f.nombre || '—' }}</td>
                  <td class="cp-email">{{ f.email || '—' }}</td>
                  <td>
                    <span v-if="f.telegram_username" class="cp-nick">@{{ f.telegram_username }}</span>
                    <span v-else class="text-muted">—</span>
                  </td>
                  <td class="text-end cp-precio">{{ formatMoney(f.precio) }}</td>
                  <td class="text-center cp-fecha">{{ fmtFechaDMY(f.fecha) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import { globalFunctionsMixin } from "@/mixins/globalFunctions.js";
import PanelPublicistaComparativa from "@/views/components/panel-publicista/PanelPublicistaComparativa.vue";
import PanelPublicistaEvolucion from "@/views/components/panel-publicista/PanelPublicistaEvolucion.vue";
import PanelPublicistaRanking from "@/views/components/panel-publicista/PanelPublicistaRanking.vue";
import PanelPublicistaGeoMeta from "@/views/components/panel-publicista/PanelPublicistaGeoMeta.vue";
import PanelPublicistaLandingsEfectivas from "@/views/components/panel-publicista/PanelPublicistaLandingsEfectivas.vue";

export default {
  name: "PanelPublicista",
  mixins: [globalFunctionsMixin],
  components: {
    PanelPublicistaComparativa,
    PanelPublicistaEvolucion,
    PanelPublicistaRanking,
    PanelPublicistaGeoMeta,
    PanelPublicistaLandingsEfectivas,
  },
  data() {
    return {
      loading: false,
      panelKey: 0,
      publicistas: [],
      publicistaId: "",
      tipsters: [],
      evolucionEntradas: [],
      resumen: {
        campanas_total: 0,
        entradas_total: 0,
        entradas_unicas_total: 0,
        suscritos_actuales_total: 0,
        salidas_total: 0,
        compras_total: 0,
        importe_total: 0,
      },
      countriesMeta: [],
      landingsEfectivas: [],
      periodo: "todo",
      periodos: [
        { key: "mes", label: "Mes actual" },
        { key: "3m",  label: "3M" },
        { key: "6m",  label: "6M" },
        { key: "12m", label: "12M" },
        { key: "todo",label: "Todo" },
      ],
      tipsterSeleccionado: "",
      sortCol: "entradas_total",
      sortDir: "desc",
      comprasModal: { visible: false, loading: false, campanaNombre: "", filas: [] },
    };
  },
  computed: {
    permisos() {
      return this.$store.state.auth?.permisos_finales || [];
    },
    canAdmin() {
      return Array.isArray(this.permisos) && this.permisos.includes("panel_publicista.admin.ver");
    },
    publicistaLabel() {
      const attrs = this.$store.state.auth?.me?.data?.attributes || {};
      if (!this.canAdmin || !this.publicistaId) {
        return (attrs.name || attrs.username || "Yo");
      }
      const p = this.publicistas.find(x => String(x.id) === String(this.publicistaId));
      return p ? `${p.name} (${p.username})` : `ID ${this.publicistaId}`;
    },
    rangoFechas() {
      const hoy = new Date();
      const fmt = d => d.toISOString().split("T")[0];
      if (this.periodo === "mes") {
        return { desde: fmt(new Date(hoy.getFullYear(), hoy.getMonth(), 1)), hasta: fmt(hoy) };
      }
      if (this.periodo === "3m") {
        const d = new Date(hoy); d.setMonth(d.getMonth() - 3);
        return { desde: fmt(d), hasta: fmt(hoy) };
      }
      if (this.periodo === "6m") {
        const d = new Date(hoy); d.setMonth(d.getMonth() - 6);
        return { desde: fmt(d), hasta: fmt(hoy) };
      }
      if (this.periodo === "12m") {
        const d = new Date(hoy); d.setFullYear(d.getFullYear() - 1);
        return { desde: fmt(d), hasta: fmt(hoy) };
      }
      return { desde: null, hasta: null };
    },
    tipstersFiltrados() {
      if (!this.tipsterSeleccionado) return this.tipsters;
      return this.tipsters.filter(t => t.tipster_id === Number(this.tipsterSeleccionado));
    },
    countriesMetaFiltrado() {
      if (!this.tipsterSeleccionado) return this.countriesMeta;
      return this.countriesMeta.filter(r => r.tipster_id === Number(this.tipsterSeleccionado));
    },
    landingsEfectivasFiltradas() {
      if (!this.tipsterSeleccionado) return this.landingsEfectivas;
      return this.landingsEfectivas.filter(r => r.tipster_id === Number(this.tipsterSeleccionado));
    },
    campanasSorted() {
      const col = this.sortCol;
      const dir = this.sortDir === "asc" ? 1 : -1;
      const numCols = ["entradas_total","entradas_unicas","reingresos_total","suscritos_actuales","salidas_total","compras","importe"];
      const isNum = numCols.includes(col);
      const rows = [];
      for (const t of this.tipstersFiltrados) {
        for (const c of (t.campanas || [])) {
          rows.push({ ...c, tipster_nombre: t.tipster_nombre });
        }
      }
      return rows.sort((a, b) => {
        const av = isNum ? (Number(a[col]) || 0) : (String(a[col] || "")).toLowerCase();
        const bv = isNum ? (Number(b[col]) || 0) : (String(b[col] || "")).toLowerCase();
        return av < bv ? -dir : av > bv ? dir : 0;
      });
    },
    resumenFiltrado() {
      const ts = this.tipstersFiltrados;
      if (!ts.length) return this.resumen;
      return {
        campanas_total:          ts.reduce((s, t) => s + (t.totales.campanas || 0), 0),
        entradas_total:          ts.reduce((s, t) => s + (t.totales.entradas_total || 0), 0),
        entradas_unicas_total:   ts.reduce((s, t) => s + (t.totales.entradas_unicas_total || 0), 0),
        suscritos_actuales_total:ts.reduce((s, t) => s + (t.totales.suscritos_actuales || 0), 0),
        salidas_total:           ts.reduce((s, t) => s + (t.totales.salidas_total || 0), 0),
        compras_total:           ts.reduce((s, t) => s + (t.totales.compras || 0), 0),
        importe_total:           ts.reduce((s, t) => s + (t.totales.importe || 0), 0),
      };
    },
  },
  watch: {
    canAdmin: {
      immediate: true,
      handler(n) { if (n) this.cargarPublicistas(); },
    },
  },
  methods: {
    fmtFechaDMY(fechaStr) {
      if (!fechaStr) return "";
      const onlyDate = String(fechaStr).split(" ")[0].split("T")[0]; // YYYY-MM-DD
      const [y, m, d] = onlyDate.split("-");
      return (y && m && d) ? `${d}-${m}-${y}` : onlyDate;
    },

    irInicio() {
      this.$router.push("/dashboard");
    },
    formatMoney(n) {
      const num = Number(n || 0);
      return num.toLocaleString("es-ES", { style: "currency", currency: "EUR" });
    },
    async abrirCompras(campanaId, campanaNombre) {
      this.comprasModal = { visible: true, loading: true, campanaNombre: campanaNombre || '', filas: [] };
      try {
        const resp = await this.$store.dispatch('auth/campanaDetalle', { campana_id: campanaId, tipo: 'pagos' });
        this.comprasModal.filas = resp.data || [];
      } catch (e) {
        this.comprasModal.filas = [];
      } finally {
        this.comprasModal.loading = false;
      }
    },
    setOrden(col) {
      if (this.sortCol === col) {
        this.sortDir = this.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.sortCol = col;
        const numCols = ["entradas_total","entradas_unicas","reingresos_total","suscritos_actuales","salidas_total","compras","importe"];
        this.sortDir = numCols.includes(col) ? "desc" : "asc";
      }
    },
    thClass(col) {
      if (this.sortCol !== col) return "";
      return this.sortDir === "asc" ? "asc" : "desc";
    },
    async cargarPublicistas() {
      try {
        const resp = await this.$store.dispatch("auth/publicistas", {});
        this.publicistas = resp.data || [];
      } catch (e) {
        console.error(e);
        // si falla, no pasa nada: el panel igual funciona para "yo mismo"
      }
    },
    setPeriodo(key) {
      this.periodo = key;
      this.cargarPanel();
    },
    async cargarPanel() {
      this.loading = true;
      try {
        const payload = {};
        if (this.canAdmin && this.publicistaId) payload.publicista_id = Number(this.publicistaId);
        const { desde, hasta } = this.rangoFechas;
        if (desde) payload.desde = desde;
        if (hasta) payload.hasta = hasta;

        const resp = await this.$store.dispatch("auth/publicistaPanel", payload);

        this.tipsters = resp.tipsters || [];
        this.resumen = resp.resumen || this.resumen;
        this.evolucionEntradas = resp.evolucion_entradas || [];
        this.countriesMeta = resp.countries_meta || [];
        this.landingsEfectivas = resp.landings_efectivas || [];
        // Preservar selección de tipster si sigue existiendo en los nuevos datos
        const selExiste = this.tipsterSeleccionado &&
          this.tipsters.some(t => t.tipster_id === Number(this.tipsterSeleccionado));
        if (!selExiste) this.tipsterSeleccionado = "";
        this.panelKey++;
      } catch (e) {
        console.error(e);
        showSwal.methods.showSwal({
          type: "error",
          message: "No se pudo cargar el panel del publicista",
          width: 520,
        });
        this.tipsters = [];
        this.evolucionEntradas = [];
        this.countriesMeta = [];
        this.landingsEfectivas = [];
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.$store.commit('setShowFooter', true);
    await this.cargarPanel();
  },
};
</script>

<style scoped>
.container-fluid { max-width: 1100px; }

/* El ficha-buscador en panel usa layout de bloque, no flex */
.ficha-buscador { display: block !important; }

.filtros-globales {
  display: flex;
  gap: 20px;
  align-items: flex-end;
  flex-wrap: wrap;
}
.filtro-bloque {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.filtro-label {
  font-size: 11px;
  font-weight: 700;
  color: var(--q-text-muted);
  text-transform: uppercase;
  letter-spacing: .05em;
  margin: 0;
}
.btn-activo  { background: #f5a623 !important; color: #1a1200 !important; border-color: #f5a623 !important; border-radius: 8px !important; font-size: 11px; font-weight: 800; padding: 5px 14px; box-shadow: 0 2px 8px rgba(245,166,35,.35); }
.btn-inactivo{ background: transparent !important; color: var(--q-text-muted); border: 1px solid var(--q-border-md) !important; border-radius: 8px !important; font-size: 11px; font-weight: 600; padding: 5px 14px; }
.btn-inactivo:hover { background: var(--q-card-alt) !important; }
.select-wrap {
  position: relative;
  width: 100%;
}
.select-wrap .form-select {
  background-color: var(--q-card-alt);
  color: var(--q-text);
  border: 1px solid var(--q-border-md);
  border-radius: 10px;
  padding: 8px 36px 8px 12px;
  font-size: 14px;
  font-weight: 500;
  appearance: none;
  width: 100%;
  cursor: pointer;
  background-image: none !important;
}
.select-wrap .form-select:focus { outline: none; border-color: var(--q-gold); box-shadow: 0 0 0 2px rgba(245,166,35,.15); }
.select-wrap::after {
  content: "▼";
  position: absolute;
  right: 12px; top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  color: var(--q-gold);
  pointer-events: none;
}
.selector-actions{ display:flex; gap:10px; flex-wrap:wrap; align-items:flex-end; }

@media (max-width: 575px) {
  .selector-actions { margin-left: 0; width: 100%; }
  .selector-actions .btn { width: 100%; }
}

.table-listado th, .table-listado td{
  padding-top:10px; padding-bottom:10px;
}

.mini-card{
  border:1px solid var(--q-border);
  background:var(--q-card-alt);
  border-radius:12px;
  padding:12px 14px;
}
.mini-card .k{ font-size:0.75rem; opacity:.7; }
.mini-card .v{ font-size:18px; font-weight:700; }

.totales-pill{
  display:flex;
  flex-wrap:wrap;
  gap:10px 14px;
  font-size:12px;
  opacity:.85;
  background:var(--q-card-alt);
  border:1px solid var(--q-border);
  padding:10px 12px;
  border-radius:12px;
}
.table-empirulada {
  border-collapse: separate !important;
  border-spacing: 0 10px;
}
.table-empirulada thead th {
  border: 0 !important;
  background: var(--q-hover);
  color: var(--q-text);
  font-weight: 700;
  padding: 12px 14px;
}
.table-empirulada tbody tr {
  background: var(--q-card-alt);
  box-shadow: 0 6px 18px rgba(0,0,0,.06);
}
.table-empirulada tbody td {
  border: 0 !important;
  padding: 12px 14px;
  vertical-align: middle;
}
.table-empirulada > :not(caption) > * > * { border-bottom-width: 0 !important; }
.table-empirulada tbody tr:hover { transform: translateY(-1px); transition: .15s ease; }
.campana-nombre{
  font-weight: 700;
  color: var(--q-text);
  line-height: 1.15;
}

.canal-sub{
  font-size: 12px;
  opacity: .75;
  line-height: 1.15;
}
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover { color: var(--q-gold); }

.compras-badge {
  display: inline-block;
  background: rgba(40,199,111,.15);
  color: #28c76f;
  font-weight: 700;
  font-size: 12px;
  border-radius: 6px;
  padding: 2px 10px;
  cursor: pointer;
  transition: background .15s;
}
.compras-badge:hover { background: rgba(40,199,111,.3); }

/* Modal compras */
.cp-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.55);
  display: flex; align-items: center; justify-content: center;
  z-index: 9999; padding: 16px;
}
.cp-box {
  background: var(--q-card);
  border: 1px solid var(--q-border);
  border-top: 3px solid #28c76f;
  border-radius: 16px;
  width: 100%; max-width: 700px;
  max-height: 80vh;
  display: flex; flex-direction: column;
  box-shadow: 0 24px 60px rgba(0,0,0,.5);
}
.cp-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  padding: 20px 24px 14px;
  border-bottom: 1px solid var(--q-border);
  gap: 12px;
}
.cp-titulo   { font-size: 15px; font-weight: 700; color: var(--q-text); }
.cp-subtitulo{ font-size: 12px; color: var(--q-text-muted); margin-top: 3px; }
.cp-cerrar   { background: none; border: none; font-size: 18px; color: var(--q-text-muted); cursor: pointer; padding: 0; line-height: 1; }
.cp-cerrar:hover { color: var(--q-text); }
.cp-body     { overflow-y: auto; padding: 16px 24px 24px; flex: 1; }
.cp-loading  { display: flex; justify-content: center; padding: 40px 0; }
.cp-spinner  { width: 28px; height: 28px; border: 3px solid var(--q-border); border-top-color: #28c76f; border-radius: 50%; animation: spin .7s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
.cp-empty    { text-align: center; padding: 40px 0; color: var(--q-text-muted); font-size: 13px; }
.cp-tabla    { width: 100%; font-size: 13px; }
.cp-tabla th { font-size: 11px; font-weight: 700; color: var(--q-text-muted); padding: 8px 10px; border-bottom: 1px solid var(--q-border); }
.cp-tabla td { padding: 10px; border-bottom: 1px solid var(--q-border-sm, var(--q-border)); vertical-align: middle; }
.cp-tabla tr:last-child td { border-bottom: none; }
.cp-nick  { font-family: monospace; font-size: 12px; color: var(--q-accent); }
.cp-email { font-size: 11px; color: var(--q-text-muted); }
.cp-precio{ font-weight: 700; font-family: var(--q-font-mono); }
.cp-fecha { font-size: 12px; color: var(--q-text-muted); white-space: nowrap; }

.reingreso-badge {
  display: inline-block;
  background: var(--q-amber-soft);
  color: var(--q-amber);
  border-radius: 6px;
  padding: 1px 7px;
  font-size: 11px;
  font-weight: 700;
}

</style>
